import { EmployerSubmissionTypeEnum } from '../../models/enum/shared/employer-submission-type.enum';

export class EmployerSubmissionPermissionUtils {
  static getViewSubmissionPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.EmployerSelfEnrolment:
        return 79;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 85;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 91;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 109;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getProcessSubmissionPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.EmployerSelfEnrolment:
        return 80;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 86;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 92;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 110;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanApproveSubmissionPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.EmployerSelfEnrolment:
        return 81;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 87;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 93;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 111;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanApproveOwnSubmissionPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.EmployerSelfEnrolment:
        return 82;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 88;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 94;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 112;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanReassignSubmissionOwnerPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.EmployerSelfEnrolment:
        return 83;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 89;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 95;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 113;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }

  static getCanCreateSubmissionPermission(submissionTypeId: EmployerSubmissionTypeEnum): number {
    switch (submissionTypeId) {
      case EmployerSubmissionTypeEnum.EmployerSelfEnrolment:
        return 84;
      case EmployerSubmissionTypeEnum.UpdateAddress:
        return 90;
      case EmployerSubmissionTypeEnum.UpdateContacts:
        return 96;
      case EmployerSubmissionTypeEnum.UpdateEmploymentStatus:
        return 114;
      default:
        throw new Error(`Unsupported submission type ID: ${submissionTypeId}`);
    }
  }
}
